export default "__VITE_ASSET__C06B$GMx__"